import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("atiti_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle expired / invalid tokens globally so the user isn't stuck on a
// "logged in but every call 401s" screen. Clear the session and bounce to
// /login (unless we're already there — avoids reload loops).
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail || "";
    const authFail =
      status === 401 &&
      /token expired|invalid token|not authenticated|user not found|team access revoked/i.test(
        typeof detail === "string" ? detail : ""
      );
    if (authFail && typeof window !== "undefined") {
      const onLogin = window.location.pathname.startsWith("/login") ||
                      window.location.pathname.startsWith("/team-login");
      if (!onLogin) {
        localStorage.removeItem("atiti_token");
        localStorage.removeItem("atiti_user");
        // Preserve where they were so we can return after re-auth.
        const back = window.location.pathname + window.location.search;
        window.location.replace(`/login?next=${encodeURIComponent(back)}&reason=expired`);
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};

export default api;
